import request from '@/utils/request'


// 推荐文章
export function getDetail(productRecommendId) {
  return request({
    url: `/v1/manager/product/recommend/`+productRecommendId,
    method: 'get',
  })
}

// 设备使用说明
export function getDeviceUse(deviceId) {
  return request({
    url: `/v1/front/user/device/use/`+deviceId,
    method: 'get',
  })
}